<div class="access-restricted-container">
  <span class="access-restricted">Access Restricted</span>
  <p>You do not have access to this section.</p>
</div>
